import 'select2/dist/js/select2.full.js'

jQuery('.activity__select select').select2({
    width: '100%'
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.tfg-content-members__select select').select2({
    width: '100%'
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.pfts select').select2({
    width: '100%'
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.nav-dropdown select').select2({
    width: '100%',
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.nav-dropdown-mobile select').select2({
    width: '100%',
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.gform_wrapper select').select2({
    width: '100%'
})

jQuery('select.BBFormSelectList').select2({
    // width: '100%'
})



jQuery('.general__dropdown select').select2({
    width: '100%'
}).on('change', function () {
    window.location = jQuery(this).val()
})
